//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../Facet/Facet.CleanupFacetBodyBuilder.js";
import "../Facet/Facet.FillMeshBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Facet/Facet.SnipFacetBodyBuilder.js";
import "../no/FacetCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AutomaticFillType",1,0],[0,"CircumferenceRings",1,0],[1,"CleanupFacetBodyBuilder",0,"Facet.CleanupFacetBodyBuilder",0],[0,"FacetCollector",1,"FacetCollector",0],[1,"FillMesh",0,"Facet.FillMeshBuilder",0],[0,"FoldedEdges",1,0],[0,"InconsistentNormals",1,0],[1,"InputBodies",0,"SelectDisplayableObjectList",0],[0,"LaminarSlits",1,0],[0,"MinAngleFoldedFacets",1,0],[0,"MinFacetNumberPerBody",1,0],[0,"QualityIndex",1,0],[0,"RegionRemoveOption",1,0],[0,"SelfIntersections",1,0],[1,"SnipFacetBodyBuilder",0,"Facet.SnipFacetBodyBuilder",0],[0,"ThinFacets",1,0],[0,"ToleranceFactor",1,0]],[[[],"Analyze",{},0,0],[[],"Repair",{},0,0],[[],"RemoveFacets",{},0,0],[[],"FillHole",{},0,0],[[],"CreateCopiesToEdit",{},0,0]],[]];
SPLM.Facet.CleanupFacetBodyWizardBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.CleanupFacetBodyWizardBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.CleanupFacetBodyWizardBuilder.JaCleanupFacetBodyBuilderRegionremoveoption = Object.freeze({
    "ByRegion" : "ByRegion", "ByDefectMarkup" : "ByDefectMarkup"});

SPLM.Facet.CleanupFacetBodyWizardBuilder.FillType = Object.freeze({
    "None" : "None", "Linear" : "Linear", "Refined" : "Refined", "TangentBased" : "TangentBased", "CurvatureBased" : "CurvatureBased"});

export default SPLM;